/**
 * Function  that return the website URI with http prefix if doesn't have.
 * @param site String website.
 * @returns the URI with http protocol
 */
export const getWebsiteUri = (site: string): string => {
  const protocol = 'https://';
  return !site?.startsWith('http://') && !site?.startsWith(protocol)
    ? `${protocol}${site}`
    : site;
};

/**
 * Function that returns google maps URL with coordinates.
 * @param latitude
 * @param longitude
 * @returns String with URL
 */
export const getDrivingDirections = (
  latitude: string | number,
  longitude: string | number
): string =>
  latitude && longitude
    ? `https://www.google.com/maps/dir/?api=1&destination=${latitude}%2C${longitude}`
    : '';

export const searchLocation = (
  latitude: string | number,
  longitude: string | number
): string =>
  latitude && longitude
    ? `https://www.google.com/maps/search/?api=1&query=${latitude}%2C${longitude}`
    : '';
    